import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'
import Marquee from "react-fast-marquee";
import { skillsData } from '../data/SkillsData';
import { skillsImage } from '../utils/SkillsImage';
import "../styles/style.css";
import Timeline from "../components/timeline";
const events = [
    { date: '2023-08 — present', title:'Computer science teacher', place: 'Hexlet College' },
    { date: '2021-09 — 2023-07', title:'Deputy director for educational work',place: 'GBOU SOSH 20 SPB' },
    { date: '2019-09 — 2023-07', title:'Computer science teacher',place: 'GBOU SOSH 20 SPB' },

];

function Aboutme() {
    return (
        <div className='about-page-background'>
            <Container>
                <Row className='text-background'>
                    <Col md={5} >
                        <h3 className='about-me-text'>About Me</h3>
                        <p className='about-me-details'>💻 I’m working on my portfolio;<br/>
                            ⌨️ I’m currently learning frontend frameworks as React and Angular, PHP language and Laravel framework;<br/>
                            👨‍🎓 Fun fact: I finished graduate school in cultural studies and was the deputy director for educational work at a St. Petersburg school;<br/>
                            👨‍🏫 Now I work as a computer science teacher at Hexlet College.
                        </p>
                        <div className="skills-container">
                                <h3 className='about-me-text'>Work experience</h3>
                                <Timeline events={events} />
                            <h3 className='about-me-text'>Languages and tools</h3>
                            <div className="skill--scroll">
                                <Marquee
                                    gradient={false}
                                    speed={90}
                                    pauseOnClick={true}
                                    delay={0}
                                    play={true}
                                    direction="right"
                                >
                                    {skillsData.map((skill, id) => (
                                        <div className="skill-box" key={id} >
                                            <img className='skill-image' src={skillsImage(skill)} alt={skill} />
                                            <p>{skill}</p>
                                        </div>
                                    ))}
                                </Marquee>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    )
}

export default Aboutme